/*
 * «Ничего на русском не уходит в Meta» (правило владельца; спека 2026-10-20
 * §4.5). Одна проверка на всех: mcp-api (отказ модели по-английски), admin-api
 * (400 с русской фразой) и форма профиля кабинета в админке (ошибка у поля).
 */
/** Любая буква кириллицы (русская, украинская, …). */
const CYRILLIC = /\p{Script=Cyrillic}/u;
/** Есть ли в строке кириллица. */
export const hasCyrillic = (s) => CYRILLIC.test(s);
/** Глубже — отказ, а не пропуск. */
const MAX_DEPTH = 32;
const isRecord = (v) => v !== null && typeof v === 'object' && !Array.isArray(v);
/**
 * Пути всех строк с кириллицей, с заходом в массивы (`a[1]`) и объекты
 * (`a.key`), в порядке входа. КЛЮЧИ объектов не проверяются (ключи реестра и
 * id — в Meta они не уходят текстом).
 */
export const findCyrillic = (fields) => {
    const out = [];
    const walk = (value, path, depth) => {
        if (depth > MAX_DEPTH) {
            // Fail-closed: what we cannot inspect is reported as a violation, never skipped.
            out.push(`${path} (nested deeper than ${MAX_DEPTH} levels — cannot be checked)`);
            return;
        }
        if (typeof value === 'string') {
            if (CYRILLIC.test(value))
                out.push(path);
        }
        else if (Array.isArray(value)) {
            value.forEach((v, i) => walk(v, `${path}[${i}]`, depth + 1));
        }
        else if (isRecord(value)) {
            for (const [k, v] of Object.entries(value))
                walk(v, `${path}.${k}`, depth + 1);
        }
    };
    for (const [path, value] of fields)
        walk(value, path, 0);
    return out;
};
/**
 * Строковые поля профиля кабинета, которые уходят в Meta текстом при каждом
 * запуске (аудит LW-02): плательщик / бенефициар DSA (`dsa_payor` /
 * `dsa_beneficiary`), ссылка по умолчанию (ссылка креатива) и домен
 * конверсий (`ad.conversion_domain`). Id, `label` (наш) и имена слотов
 * аудиторий (ключи; auto-ads меняет их на id) — не текст для Meta;
 * роли и категории регуляторных данных уже ограничены латиницей схемой.
 */
export const ADS_PROFILE_META_TEXT_FIELDS = [
    'dsaPayor',
    'dsaBeneficiary',
    'defaultLink',
    'conversionDomain',
];
/** Названия этих полей для человека — как в форме профиля кабинета. */
export const ADS_PROFILE_META_TEXT_LABELS = {
    dsaPayor: 'DSA: кто платит',
    dsaBeneficiary: 'DSA: в чьих интересах',
    defaultLink: 'Ссылка по умолчанию',
    conversionDomain: 'Домен конверсий',
};
/** Поля профиля для {@link findCyrillic}; путь — имя поля. */
export function* profileCyrillicFields(input) {
    for (const k of ADS_PROFILE_META_TEXT_FIELDS)
        yield [k, input[k]];
}
/** Ошибка у одного поля формы. */
export const LATIN_ONLY_FIELD_MESSAGE = 'Только латиница: этот текст уходит в Meta, кириллицу туда отправлять нельзя';
/**
 * Фраза для человека об отказе по полям профиля (admin-api, 400): какие поля
 * и что сделать.
 */
export const latinOnlyProfileMessage = (fields) => {
    const names = fields.map((f) => `«${ADS_PROFILE_META_TEXT_LABELS[f]}»`).join(', ');
    return fields.length === 1
        ? `Поле ${names} уходит в Meta и должно быть написано латиницей — уберите кириллицу`
        : `Поля ${names} уходят в Meta и должны быть написаны латиницей — уберите кириллицу`;
};
/** Поля профиля с кириллицей, в порядке {@link ADS_PROFILE_META_TEXT_FIELDS}. */
export const profileCyrillicFieldKeys = (input) => findCyrillic(profileCyrillicFields(input));
//# sourceMappingURL=latin-only.js.map